import React from 'react';
import AutoRedirector from './AutoRedirector';

function App() {
  return (
    <AutoRedirector />
  );
}

export default App;